
//  last race
// [
//     {
//         "1": {"place": 1, "firsts": 1, "seconds": 0, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 0, "totalScore": 2},
//         "2": {"place": 2, "firsts": 0, "seconds": 1, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 0, "totalScore": 1},
//         "3": {"place": 3, "firsts": 0, "seconds": 0, "thirds": 1, "fourths": 0, "lasts": 1, "notPlayed": 0, "totalScore": 0},
//         "4": {"place": 0, "firsts": 0, "seconds": 0, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 0, "totalScore": 1},
//         "5": {"place": 0, "firsts": 0, "seconds": 0, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 0, "totalScore": 0},            
//     },
// ]

// input = [{playerId, place}, ...]

function getPlaceKey(place) {
    switch(place) {
        case 0:
          return 'notPlayed';
        case 1:
          return "firsts";
        case 2:
        return "seconds";
        case 3:
            return "thirds";
        case 4:
            return "fourths";
        default:
          throw Error("Invalid place: "+toString(place));
      }
      
}

function getScoreIncrement(place, ruleParameter, groupSize) {
    const effectiveParameter = Math.min(ruleParameter, groupSize - 1);
    let increment = groupSize - place - effectiveParameter + 1

    if (increment < 1) {
        return 0;
    } else {
    return increment;
    }
}

function getRuleParameter (ruleId) {

    if (parseInt(ruleId) < 4 && parseInt(ruleId) >= 0) {
        return parseInt(ruleId);
    } else if (parseInt(ruleId) === 4) {
        return 0;
    } else {
        throw Error("Invalid rule id provided.")
    }
        
    };

    // [
    //     {"fullName": "Zach Boesen", "playerId": "5", "characterId": "1"},
    //     {"fullName": "Franco Sposito", "playerId": "2", "characterId": "8"},
    //     {"fullName": "Alex Gilmore", "playerId": "1", "characterId": "6"},
    //     {"fullName": "Tom Gilman", "playerId": "3", "characterId": "7"},
    //     {"fullName": "Brockton Anderson", "playerId": "4", "characterId": "5"},
    //     {"fullName": "Wyatt Nusser", "playerId": "6", "characterId": "2"},   
    //     {"fullName": "Josh Hennen", "playerId": "23", "characterId": "3"}      
    // ]

    // {
    //     "courseId": "1",
    //     'racePlayers': {
    //     "1": {"place": 1, "fullName": "Alex Gilmore","characterId": "1","firsts": 1, "seconds": 0, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 0,  "totalScore": 2},
    //     "2": {"place": 2, "fullName": "Alex Gilmore","characterId": "2","firsts": 0, "seconds": 1, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 0,  "totalScore": 1},
    //     "3": {"place": 3, "fullName": "Alex Gilmore","characterId": "3","firsts": 0, "seconds": 0, "thirds": 1, "fourths": 0, "lasts": 1, "notPlayed": 0,  "totalScore": 0},

    //     "4": {"place": 0, "fullName": "Alex Gilmore","characterId": "","firsts": 0, "seconds": 0, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 1,  "totalScore": 0},
    //     "5": {"place": 0, "fullName": "Alex Gilmore","characterId": "","firsts": 0, "seconds": 0, "thirds": 0, "fourths": 0, "lasts": 0, "notPlayed": 1,  "totalScore": 0},
    //     }
    // },
function initHistory(grandPrixRoster) {
    // Create a deep copy of the roster to avoid mutating the original
    const roster = JSON.parse(JSON.stringify(grandPrixRoster));
    const players = {};
    
    roster.forEach(player => {
        // Ensure we have a valid player ID
        const playerId = String(player.playerId || '').trim();
        if (!playerId) {
            console.warn("Player missing ID, skipping:", player);
            return;
        }
        
        // Get the most reliable name sources
        let fullName = '';
        if (player.fullName && typeof player.fullName === 'string') {
            fullName = player.fullName.trim();
        } else if (player.firstName || player.lastName) {
            fullName = `${player.firstName || ''} ${player.lastName || ''}`.trim();
        } else {
            fullName = `Player ${playerId}`;
        }
        
        // Get character ID with fallback
        const characterId = String(player.characterId || '0');
        
        // Create player object with consistent structure
        players[playerId] = {
            // Primary data
            playerId,
            fullName,
            characterId,
            
            // Stats
            place: 0,
            firsts: 0,
            seconds: 0,
            thirds: 0,
            fourths: 0,
            lasts: 0,
            notPlayed: 0,
            totalScore: 0,
            
            firstName: fullName.split(' ')[0] || '',
            lastName: fullName.split(' ').slice(1).join(' ') || ''
        };
    });
    
    return [{
        courseId: "0",
        racePlayers: players,
        timestamp: new Date().toISOString()
    }];
}


function updateScores(scoreHistory, raceToAdd, ruleId, savedRoster = []) {
    try {
        const ruleParameter = getRuleParameter(ruleId);
        
        // Validate inputs
        if (!Array.isArray(scoreHistory) || scoreHistory.length === 0) {
            throw new Error("Invalid score history: must be a non-empty array");
        }
        
        if (!raceToAdd || !raceToAdd.racePlayers || !Array.isArray(raceToAdd.racePlayers)) {
            throw new Error("Invalid race data: missing or invalid racePlayers array");
        }
        
        // Create deep copies to avoid mutating the original objects
        const lastRace = JSON.parse(JSON.stringify(scoreHistory[scoreHistory.length - 1]));
        const newRaceEntry = {
            courseId: String(raceToAdd.courseId || '0'),
            racePlayers: {},
        };
        
        // Track which players were in this race
        const playersInRace = new Set();
        
        const savedPlayers = new Map(savedRoster.map((player) => [
            String(player.playerId || ''),
            player,
        ]));

        // Process players who participated in this race
        raceToAdd.racePlayers.forEach(racePlayer => {
            // Get player ID with validation
            const playerId = String(racePlayer.playerId || '').trim();
            if (!playerId) {
                console.warn("Skipping player with missing ID:", racePlayer);
                return;
            }
            
            // Get the player's previous data
            const rosterPlayer = savedPlayers.get(playerId) || racePlayer;
            const rosterName = rosterPlayer.fullName ||
                `${rosterPlayer.firstName || ''} ${rosterPlayer.lastName || ''}`.trim();
            const previousData = lastRace.racePlayers[playerId] || {
                playerId,
                fullName: rosterName || `Player ${playerId}`,
                characterId: String(rosterPlayer.characterId || '0'),
                firsts: 0,
                seconds: 0,
                thirds: 0,
                fourths: 0,
                lasts: 0,
                notPlayed: 0,
                totalScore: 0,
            };
            
            // Mark player as participating in this race
            playersInRace.add(playerId);
            
            // Calculate race results
            const place = parseInt(racePlayer.place, 10) || 0;
            const placeKey = getPlaceKey(place);
            const scoreIncrement = getScoreIncrement(place, ruleParameter, raceToAdd.racePlayers.length);
            
            // Get the most reliable name and character data
            const fullName = previousData.fullName ||
                           (previousData.firstName && previousData.lastName ?
                            `${previousData.firstName} ${previousData.lastName}` :
                            `Player ${playerId}`);
                            
            const characterId = String(
                racePlayer.characterId || previousData.characterId || '0'
            );
            
            // Calculate new stats
            const stats = {
                firsts: previousData.firsts || 0,
                seconds: previousData.seconds || 0,
                thirds: previousData.thirds || 0,
                fourths: previousData.fourths || 0,
                lasts: previousData.lasts || 0,
                notPlayed: previousData.notPlayed || 0,
                totalScore: previousData.totalScore || 0
            };
            
            // Update stats based on current race
            if (placeKey in stats) {
                stats[placeKey]++;
            }
            if (place === raceToAdd.racePlayers.length) {
                stats.lasts++;
            }
            stats.totalScore += scoreIncrement;
            
            // Create updated player data with consistent structure
            newRaceEntry.racePlayers[playerId] = {
                // Core player info (from roster)
                playerId,
                fullName,
                characterId,
                
                // Current race data
                place,
                
                // Updated stats
                ...stats,
                firstName: fullName.split(' ')[0] || '',
                lastName: fullName.split(' ').slice(1).join(' ') || '',
            };
        });
        
        // Handle players who didn't race this time
        Object.entries(lastRace.racePlayers).forEach(([playerId, playerData]) => {
            if (!playersInRace.has(playerId)) {
                // Player didn't race this time, increment notPlayed counter
                newRaceEntry.racePlayers[playerId] = {
                    ...playerData,
                    place: 0, // Indicates didn't race
                    notPlayed: (playerData.notPlayed || 0) + 1
                };
            }
        });
        
        // Update race timestamp
        newRaceEntry.timestamp = new Date().toISOString();
        
        // Handle first race (replace initialization entry)
        if (scoreHistory.length === 1 && scoreHistory[0].courseId === "0") {
            return [newRaceEntry];
        }
        
        // Add new race to history
        const updatedHistory = [...scoreHistory];
        updatedHistory.push(newRaceEntry);
        
        return updatedHistory;
        
    } catch (error) {
        console.error("Error updating scores:", error);
        // Return original history if there was an error to prevent data corruption
        return scoreHistory;
    }
}

module.exports = {
    updateScores,
    getPlaceKey,
    getScoreIncrement,
    getRuleParameter,
    initHistory
}
